module.exports = __webpack_public_path__ + "static/media/payment-success.d57232a3.svg";